<template>
    <section v-if="modele_analyse">
        <div class="row mb-2">
            <div class="col-lg-12" v-if="container === 'modal' && (isSuccess || isError) && message">
                <div :class="`alert alert-${isError ? 'danger' : 'success'} alert-dismissible fade show`" role="alert">
                    {{ message }}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
            
            <div class="results-section col-md-12">
                <table class="w-100 results-table">
                    <thead v-if="modele_analyse?.meta.table_header_name">
                        <tr class="mb-2">
                            <th :colspan="headerRowLength" class="w-100 text-center">
                                {{ modele_analyse?.meta.table_header_name }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            v-for="(row, rowIndex) in resultats_analyses?.data" 
                            :key="rowIndex" 
                            :class="{ 'bold-first-row': rowIndex === 0 }"
                        >
                            <td
                                class="w-100 p-0" v-for="(cell, cellIndex) in row.cells" :key="cellIndex"
                                :class="{'has-content': cell.value?.trim().length > 0 }"
                                @click="cellClickHandler(row, cell, cellIndex)"
                            >
                                <template v-if="!cell.subcells || cell.subcells?.length === 0">
                                    <button v-if="cellIndex === 0 && rowIndex > 0" class="mx-1 remove-row" @click="removeRow($event, rowIndex)">
                                        <b-icon icon="x" variant="danger"></b-icon>
                                    </button>
                                    <span style="min-height: 36px;" v-html="removeParagraph(cell.value)"></span>
                                </template>

                                <div v-else :class="cell.horizontal ? 'd-flex flex-row' : 'd-flex flex-column'">
                                    <div v-for="(subcell, subcellIndex) in cell.subcells"
                                        :key="subcellIndex" class="w-100"
                                        :style="{
                                            'background-color': subcell.value?.trim().length > 0 ? '#F2F8FF' : '',
                                            borderRight: cell.horizontal && subcellIndex < cell.subcells.length - 1 ? '1px solid #87A0C7' : '',
                                            borderBottom: !cell.horizontal && subcellIndex < cell.subcells.length - 1 ? '1px solid #87A0C7' : '',
                                        }"
                                        @click="subcellClickHandler($event, subcell, cellIndex, subcellIndex)">
                                        
                                        <span style="min-height: 34px;" v-html="removeParagraph(subcell.value)" class="d-flex align-items-center justify-content-center"></span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row mb-2 mx-1">
            <div class="col-md-12">
                <h6>Commentaire/Interprétation</h6>
                <vue-editor v-model="resultats_analyses.comment" :editorToolbar="customToolbar" class="mt-2" id="editor" />
            </div>
        </div>

        <div class="row mx-1">
            <div class="col-md">
                <h6>Date d’analyse</h6>
            </div>
            <div class="col-md">
                <popper ref="datetimePopover" trigger="clickToOpen" :options="{
                    placement: 'bottom',
                    modifiers: { offset: { offset: '0,10px' } }
                }">
                    <div class="popper">
                        <div class="d-flex flex-column align-items-start">
                            <label for="datetime">Sélectionner la date</label>
                            <input type="datetime-local" v-model="resultats_analyses.recorded_at" id="datetime" />
                            <button class="btn btn-primary w-100 py-0 mt-1" @click="closePopper">Enregistrer</button>
                        </div>
                    </div>
                    <h6 class="text-primary cursor-pointer" slot="reference">
                        {{ datetimeLabel }}
                        <b-icon icon="caret-down-fill" variant="primary"></b-icon>
                    </h6>
                </popper>
            </div>
            <div class="col-6"></div>
        </div>

        <div
            class="modal fade"
            :class="{'results-editor' : container === 'modal'}"
            tabindex="-1"
            :id="`resultats-analyse-modal-${this.uniqueRef}`"
            role="dialog"
            aria-hidden="true"
            data-bs-backdrop="false"
            aria-labelledby="resultats-analyse-modal"
        >
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="resultats-analyse-modal">
                            Saisie de données | <span class="text-primary" v-html="removeParagraph(selected_row_label)"></span>
                        </h5>
                        <button type="button" class="close" @click="closeResultEditorModal($event)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ClipBoard />
                        <vue-editor 
                            v-model="currentCell.value" 
                            :editorToolbar="customToolbar" 
                            ref="e_editor"
                        />

                        <div class="row justify-content-end mt-4">
                            <button type="button" class="btn btn-sm btn-secondary-light-o btn-radius mr-2" @click="closeResultEditorModal($event)">Fermer</button>
                            <button type="button" class="btn btn-sm btn-primary btn-radius px-4" @click="closeResultEditorModal($event)">Valider</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-end mx-2">
            <div class="mr-2">
                <button type="button" class="btn btn-secondary-light-o btn-radius" @click="goBack">
                    Retour
                </button>
            </div>
            <!-- <div v-if="showPrintButton">
                <button 
                    type="button" 
                    class="btn btn-success btn-radius" 
                    @click="printResultatAnalyse()" 
                    :disabled="is_printing"
                >
                    <span><i class="fa fa-print"></i> Imprimer &nbsp;</span>
                    <span v-if="is_printing" class="spinner-border spinner-sz-1"></span>
                </button>                
            </div> -->
            <div class="col-auto">
                <button type="button" class="btn btn-primary btn-radius" @click="saveResults" :disabled="isLoading">
                    {{ (isSuccess || results_mode === 'edit') ? 'Modifier' : 'Enregistrer' }}
                    <div class="spinner-border text-white" v-if="isLoading" role="status">
                        <span class="sr-only ">Loading...</span>
                    </div>
                </button>
            </div>
        </div>  

    </section>
</template>

<script>
import $ from 'jquery';
// import moment from 'moment';
import { getFormattedDateTime } from '@/utils/datetime';
import { showToast } from '@/utils/notifications';
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import ClipBoard from '@/components/clipboard';

// import ResultsPDFVersion from '../components/Resultats-version-PDF.vue';

export default {
    name: 'ResultatsAnalysesFormTable',
    props: {
        container: String,
    },
    components: {
        VueEditor, ClipBoard, 
        'popper': Popper,
    },

    data() {
        return {
            customToolbar: vueEditorToolbar,
            datetimeLabel: "Aujourd'hui",
            currentCell: {
                value: null,
                editable: true,
                subcells: [],
            },
            resultats_analyses: {
                meta: {},
                data: [],
                comment: '',
                recorded_at: null,
                show_cachet: true,
                show_signature: true,
                model_analyse_id: null,
                bulletin_analyse_id: null,
            },
            isLoading: false,
            isSuccess: false,
            isError: false,
            showPrintButton: false,
            message: '',
            uniqueRef: `${(new Date()).getTime()}`,
            can_print: false,
            selected_row_label: ""
        }
    },

    computed: {
        patient_meta_data() {
            return this.$store.getters.patientMetaData
        },

        modele_analyse() {
            return this.$store.getters.current_modele_analyse
        },

        headerRowLength() {
            let maxLength = 0;
            if(this.results_mode === 'add' && this.modele_analyse !== null) {
                for (const row of this.modele_analyse?.meta?.rows) {
                    maxLength = Math.max(maxLength, row.cells.length);
                }
            } 
            if(this.results_mode === 'edit') {
                const rows = this.resultats_analyses?.data || [];
                for (const row of rows) {
                    maxLength = Math.max(maxLength, row.cells.length);
                }
            }
            return maxLength;
        },

        saved_resultats() {
            return this.$store.getters.resultatsAnalyse
        },

        results_mode() {
            return this.$store.getters.resultsMode;
        },

        user() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    watch: {
        'resultats_analyses.recorded_at': function (newValue) {
            // Vérifier si la date sélectionnée est dans le futur
            const selectedDate = new Date(newValue).getTime();
            const currentDate = new Date().getTime();

            if (selectedDate > currentDate) {
                this.resultats_analyses.recorded_at = new Date();
                this.closePopper();
            } else {
                this.datetimeLabel = this.getFormattedDateTime(newValue);
                this.closePopper();
            }
        },

        modele_analyse: function () {
            this.initializeResults();
        },

        saved_resultats: function () {
            if(this.saved_resultats && !this.isSuccess) {
                this.initializeResults();
            }
        }
    },

    mounted() {
        // if(!this.container || this.container !== 'modal') {
        //     this.initializeResults();
        // }
        this.initializeResults();
    },

    methods: {
        async saveResults() {
            this.isLoading = true;
            this.isError = false;

            const analyseId = this.modele_analyse.analyse.id;
            

            try {
                let response = null;

                if(this.isSuccess || this.results_mode === 'edit') {
                    this.saved_resultats.meta.doctor_fullname = this.patient_meta_data.doctor_fullname
                    const updatedResults = {
                        ...this.saved_resultats,
                        resultat_id: this.saved_resultats.id,
                        recorded_at: this.resultats_analyses.recorded_at,
                        comment: this.resultats_analyses.comment,
                        
                    }

                    console.log(">> ",this.saved_resultats);
                    console.log(">> ",this.resultats_analyses);
                    console.log(">> ",updatedResults);
                    
                    updatedResults.meta.methodology_applied = this.modele_analyse.analyse.technique_utilisee
                    response = await this.$store.dispatch("updateResultatsAnalyse", updatedResults);
                } else {

                    if (this.resultats_analyses?.recorded_at !== undefined && this.resultats_analyses.recorded_at !== null) {
                        this.resultats_analyses.recorded_at = this.resultats_analyses.recorded_at.replace('T', ' ');
                    }
                    this.resultats_analyses.analyse_id = analyseId
                    
                    this.resultats_analyses.meta.methodology_applied = this.modele_analyse.analyse.technique_utilisee

                    console.log(">> ",this.resultats_analyses);
                    
                    response = await this.$store.dispatch("saveResultatsAnalyse", { analyseId, data: this.resultats_analyses });
                }

                this.isLoading = false;

                if (response?.status === 201 || response?.status === 200) {

                    this.isSuccess = true;
                    this.showPrintButton = true;
                    
                    this.message = `Résultats d'analyse ${this.saved_resultats ? 'mis à jour' : 'enregistré'} avec succès`;

                    this.$store.dispatch("setResultatsAnalyse", response?.data);
                    this.$store.dispatch("setResultsMode", "edit");

                    this.$emit("onResultSavedSuccessfully");

                    if(this.container !== 'modal') {
                        showToast(this.message, 'success');
                    }
                }
            } catch (error) {
                this.isLoading = false;
                this.isError = true;
                this.message = "Erreur lors de la sauvegarde. Veuillez reessayer!";
            }

            setTimeout(() => {
                this.isSuccess = false;
                this.isError = false;
                this.message = '';
            }, 5000);
        },

        cellClickHandler(row, cell) {
            this.selected_row_label = row.cells[0].value
            this.currentCell = cell;

            $(`#resultats-analyse-modal-${this.uniqueRef}`).modal('show');
            
            setTimeout(() => {
                this.$refs.e_editor.quill.focus()
            }, 500);
        },

        subcellClickHandler(event, subcell) {
            event.stopPropagation();

            this.currentCell = subcell;
            $(`#resultats-analyse-modal-${this.uniqueRef}`).modal('show');
        },
        removeParagraph(text) {
            return text?.replace(/<p>/g, '').replace(/<\/p>/g, '');
        },

        initializeResults() {
            
            this.resultats_analyses.data = this.results_mode === 'add' ? this.modele_analyse?.meta.rows : this.saved_resultats?.data;
            this.resultats_analyses.comment =  this.results_mode === 'add' ? '' : this.saved_resultats?.comment;
            this.resultats_analyses.model_analyse_id = this.modele_analyse?.id;

            this.resultats_analyses.bulletin_analyse_id = this.patient_meta_data.bulletin_analyse_id;

            let biologiste_title = ''
            biologiste_title = (this.activeRole.nom == "ROLE_MEDECIN_BIOLOGISTE")?'Le médecin biologiste':(this.activeRole.nom == "ROLE_TECH_SUP_LABO")?'Le Technicien Supérieur de Laboratoire':''

            this.resultats_analyses.meta = {
                table_header_name: this.modele_analyse?.meta.table_header_name,
                biologiste_id: this.user.id,
                biologiste_title: biologiste_title,
                biologiste_fullname: this.user.name,
                biologiste_email: this.user.email,
                patient_id: this.patient_meta_data.patient?.patient_id,
                ...this.resultats_analyses.meta,
                ...this.patient_meta_data,
            }

            if(this.results_mode === 'edit' && this.saved_resultats) {
                this.resultats_analyses.recorded_at = this.saved_resultats?.recorded_at;
                this.resultats_analyses.meta.doctor_fullname = this.patient_meta_data.doctor_fullname

                const recordedAt = this.saved_resultats?.recorded_at;
                
                if (recordedAt) {
                    this.datetimeLabel = this.getFormattedDateTime(recordedAt);
                }

            }else{
                this.datetimeLabel = "Aujourd'hui";
            }


            this.isSuccess = false;
        },

        closePopper() {
            this.$refs.datetimePopover.showPopper = false;
        },

        closeResultEditorModal(event) {
            event.preventDefault();
            event.stopPropagation();

            $(`#resultats-analyse-modal-${this.uniqueRef}`).modal('hide');
        },

        goBack() {
            if(this.container === 'modal') {
                this.$emit('closeModal')
            }else{
                this.$router.go(-2)
            }
        },

        removeRow(event, index) {
            event.preventDefault();
            event.stopPropagation();

            this.resultats_analyses.data.splice(index, 1);
        },

        getFormattedDateTime,

        generateFilename(patientFullname) {
            const timestamp = new Date().getTime();
            const sanitizedFullname = patientFullname.replace(/ /g, '_');
            return `Resultats-analyse-${sanitizedFullname}-${timestamp}.pdf`;
        },
        
        printResultatAnalyse() {
            this.$emit('emitSetResult', this.saved_resultats)
        },
    }
}
</script>

<style src="../styles/resultats-analyse.scss" lang="scss" scoped></style>